import { FC } from 'react';
import {
  LinkConfigurationsOutputData,
  OpenInputType,
} from '../../../../middlewares/Open/openTypes';
import DescriptionExtensionField from '../Fields/DescriptionExtensionField';
import DescriptionField from '../Fields/DescriptionField';
import RemoteTextField from '../Fields/RemoteTextField';
import TextField from '../Fields/TextField';
import SelectFields from '../Fields/SelectFields';

interface LinkConfigurationsInputFieldProps {
  linkConfiguration: LinkConfigurationsOutputData;
  displayInputs: OpenInputType;
  dismissedFields: { [key: string]: boolean };
  errors: { [key: string]: string | null };
  inputs: OpenInputType;
  onDismissField: (name: string, dismiss: boolean) => void;
  handleRemoteChange: (name: string, value: string | number) => void;
}

const LinkConfigurationsInputField: FC<LinkConfigurationsInputFieldProps> = (
  props
) => {
  const {
    linkConfiguration,
    displayInputs,
    dismissedFields,
    errors,
    inputs,
    onDismissField,
    handleRemoteChange,
  } = props;

  const fieldTypeDict = {
    'LinkConfigurations::Text': (
      <TextField
        key={linkConfiguration.id}
        inputs={displayInputs}
        linkConfiguration={linkConfiguration}
        dismissed={dismissedFields[linkConfiguration.name]}
        onDismissField={onDismissField}
        error={errors[linkConfiguration.name]}
      />
    ),
    'LinkConfigurations::RemoteText': (
      <RemoteTextField
        key={linkConfiguration.id}
        inputs={inputs}
        displayInputs={displayInputs}
        onChangeInput={handleRemoteChange}
        linkConfiguration={linkConfiguration}
        dismissed={dismissedFields[linkConfiguration.name]}
        onDismissField={onDismissField}
        error={errors[linkConfiguration.name]}
      />
    ),
    'LinkConfigurations::Description': (
      <DescriptionField
        key={linkConfiguration.id}
        inputs={displayInputs}
        linkConfiguration={linkConfiguration}
        dismissed={dismissedFields[linkConfiguration.name]}
        onDismissField={onDismissField}
      />
    ),
    'LinkConfigurations::DescriptionExtensionField': (
      <DescriptionExtensionField
        key={linkConfiguration.id}
        inputs={displayInputs}
        linkConfiguration={linkConfiguration}
        dismissed={dismissedFields[linkConfiguration.name]}
        onDismissField={onDismissField}
      />
    ),
    'LinkConfigurations::ChangingOptionsSelect': (
      <SelectFields
        key={linkConfiguration.id}
        inputs={displayInputs}
        linkConfiguration={linkConfiguration}
        dismissed={dismissedFields[linkConfiguration.name]}
        onDismissField={onDismissField}
        error={errors[linkConfiguration.name]}
        optionLabel={'asdas'}
        handleChange={() => 'asdsa'}
      />
    ),
  };

  if (linkConfiguration.customFieldType in fieldTypeDict) {
    return fieldTypeDict[
      linkConfiguration.customFieldType as keyof typeof fieldTypeDict
    ];
  }
  return (
    <TextField
      key={linkConfiguration.id}
      inputs={displayInputs}
      linkConfiguration={linkConfiguration}
      dismissed={dismissedFields[linkConfiguration.name]}
      onDismissField={onDismissField}
      error={errors[linkConfiguration.name]}
    />
  );
};

export default LinkConfigurationsInputField;
